var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex flex-center"},[_c('img',{staticStyle:{"width":"200px","height":"200px"},attrs:{"alt":"Quasar logo","src":require("../assets/logo.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }